export default __webpack_public_path__ + "images/checkout_results_footer_Mobile.jpg";